import { createActionCreator } from '../../utils/helpers';

import { offersHistory } from './types';

export const requestOffersHistory = createActionCreator(
  offersHistory.request,
  'matchId',
  'promise',
);
export const requestOffersHistorySuccess = createActionCreator(
  offersHistory.success,
  'matchId',
  'response',
);
export const requestOffersHistoryFailure = createActionCreator(offersHistory.failure, 'error');
